export default "__VITE_ASSET__Dfvk6lkQ__"